/**
 * Evento para enviar un mensaje de WhatsApp
 */
export interface WhatsAppMessageSendEventData {
  // Identificadores
  gymId: string;
  instanceName: string; // Nombre de la instancia de Evolution API

  // Destinatario
  phoneNumber: string;

  // Contenido
  content: string;

  // Metadata opcional
  messageId?: string;
  clientId?: string;
  templateId?: string;
  variables?: Record<string, any>;

  // Usuario que generó el envío
  userId?: string;
}

/**
 * Evento para reintentar un mensaje de WhatsApp
 * El mensaje ya está construido, solo necesita ser reenviado
 */
export interface WhatsAppMessageRetryEventData {
  messageId: string; // ID del mensaje a reintentar
  gymId: string; // ID del gimnasio
  userId?: string; // Usuario que solicitó el reintento

  // Datos del mensaje necesarios para el reintento
  content: string; // Contenido del mensaje
  recipientPhone: string; // Teléfono del destinatario
  instanceName: string; // Nombre de la instancia de Evolution API
}

/**
 * Nombres de eventos de WhatsApp
 */
export const WHATSAPP_EVENTS = {
  MESSAGE_SEND: 'whatsapp/message.send',
  MESSAGE_RETRY: 'whatsapp/message.retry',
  MESSAGE_RECEIVED: 'whatsapp/message.received',
  CONNECTION_UPDATE: 'whatsapp/connection.update',
} as const;
